
// Previously registered user
export const getPRU = () => {
  return localStorage.getItem('pru');
};

// Previously registered user
export const setPRU = (data: string) => {
  window.localStorage.setItem('pru', data);
};

